import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['María', 'Lucas', 'Carolina', 'Andrea', 'Roberto', 'Valentina', 'Martín', 'Sofía', 'Diego', 'Camila'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Salta', 'Entre Ríos', 'Misiones', 'Chaco', 'San Juan'];
const PRODUCTS = ['Pack Básico', 'Pack Completo'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    province: '',
    product: ''
  });
  const showPopup = useCallback(() => {
    setCurrentPurchase({
      name: NAMES[Math.floor(Math.random() * NAMES.length)],
      province: PROVINCES[Math.floor(Math.random() * PROVINCES.length)],
      product: Math.random() < 0.3 ? PRODUCTS[0] : PRODUCTS[1]
    });
    setIsVisible(true);
  }, []);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let showTimer: ReturnType<typeof setTimeout>;
    const scheduleNext = () => {
      const delay = Math.floor(Math.random() * 4000) + 8000;
      showTimer = setTimeout(() => {
        showPopup();
        hideTimer = setTimeout(() => {
          setIsVisible(false);
          scheduleNext();
        }, 4000);
      }, delay);
    };
    showTimer = setTimeout(() => {
      showPopup();
      hideTimer = setTimeout(() => {
        setIsVisible(false);
        scheduleNext();
      }, 4000);
    }, 3000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showTimer);
    };
  }, [showPopup]);
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start gap-3 transition-all duration-300 ${isVisible ? 'opacity-100 translate-x-0 translate-y-0' : 'opacity-0 -translate-x-24 translate-y-5 pointer-events-none'}`} data-id="element-202">
      <div className="mt-1 flex-shrink-0" data-id="element-203">
        <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-204" />
      </div>
      <div data-id="element-205">
        <p className="text-sm text-gray-800" data-id="element-206">
          <span className="font-bold" data-id="element-207">{currentPurchase.name}</span> de{' '}
          <span className="font-bold" data-id="element-208">{currentPurchase.province}</span>,
          Argentina acaba de comprar el
        </p>
        <p className="text-sm font-bold text-blue-600 mt-1" data-id="element-209">
          {currentPurchase.product}!
        </p>
        <p className="text-xs text-gray-400 mt-1" data-id="element-210">Hace unos segundos</p>
      </div>
    </div>;
}